import { ROLES, User } from "../components/Authentication";

const isAvailable = (path: string | string[], user: User) => {
    const loadApis: Record<string, string[]> = {
        "/events": ["events/index"],
        "/libraries": ["venueLibs/index"],
        "/configs": ["configs/index"],
        "/health_monitor": ["healthMonitor/index"],
        "/statistics": ["statistics/index"],
        "/history": ["history/index"],
        "/unsupported_sources": ["configs/missing_sources"],
        "/heartbeats": ["events/index"],
    };

    if (path === "/admin") {
        return user.roles.some((role) => [ROLES.ADMIN, ROLES.SUPER_ADMIN].includes(role));
    }

    if (user.roles.includes(ROLES.SUPER_ADMIN) || user.resources["*"]?.includes("any")) {
        return true;
    }

    let apis = [];
    if (Array.isArray(path)) {
        apis = path;
    } else {
        apis = loadApis[path];
    }

    for (const api of apis) {
        const [key, value] = api.split("/");
        if (user.resources[key]?.includes(value) || user.resources[key]?.includes("any")) {
            return true;
        }
    }
    return false;
};

export default isAvailable;
